import {
  GET_SCHEDULED_REPORTS,
  GET_SCHEDULED_REPORTS_SUCCESS,
  GET_SCHEDULED_REPORTS_ERROR,
  CREATE_SCHEDULED_REPORTS,
  CREATE_SCHEDULED_REPORTS_SUCCESS,
  CREATE_SCHEDULED_REPORTS_ERROR,
  UPDATE_SCHEDULED_REPORTS,
  UPDATE_SCHEDULED_REPORTS_SUCCESS,
  UPDATE_SCHEDULED_REPORTS_ERROR,
  DELETE_SCHEDULED_REPORTS,
  DELETE_SCHEDULED_REPORTS_SUCCESS,
  DELETE_SCHEDULED_REPORTS_ERROR,
  RESET_LAST_SCHEDULED_REPORTS_ACTION,
  GET_SCHEDULED_REPORT_LOGS_BY_ID,
  GET_SCHEDULED_REPORT_LOGS_BY_ID_SUCCESS,
  GET_SCHEDULED_REPORT_LOGS_BY_ID_ERROR,
  REDIRECT_TO_DOWNLOAD_URL,
  REDIRECT_TO_DOWNLOAD_URL_SUCCESS,
  REDIRECT_TO_DOWNLOAD_URL_ERROR
} from "./actionTypes"

export const getScheduledReports = () => {
  return {
    type: GET_SCHEDULED_REPORTS,
  }
}

export const getScheduledReportsSuccess = scheduled_reports => {
  return {
    type: GET_SCHEDULED_REPORTS_SUCCESS,
    payload: scheduled_reports,
  }
}

export const getScheduledReportsError = error => {
  return {
    type: GET_SCHEDULED_REPORTS_ERROR,
    payload: error,
  }
}

export const createScheduledReports = payload => {
  return {
    type: CREATE_SCHEDULED_REPORTS,
    payload: payload
  }
}

export const createScheduledReportsSuccess = scheduled_reports => {
  return {
    type: CREATE_SCHEDULED_REPORTS_SUCCESS,
    payload: scheduled_reports,
  }
}

export const createScheduledReportsError = error => {
  return {
    type: CREATE_SCHEDULED_REPORTS_ERROR,
    payload: error,
  }
}

export const updateScheduledReports = payload => {
  return {
    type: UPDATE_SCHEDULED_REPORTS,
    payload: payload
  }
}

export const updateScheduledReportsSuccess = scheduled_reports => {
  return {
    type: UPDATE_SCHEDULED_REPORTS_SUCCESS,
    payload: scheduled_reports,
  }
}

export const updateScheduledReportsError = error => {
  return {
    type: UPDATE_SCHEDULED_REPORTS_ERROR,
    payload: error,
  }
}

export const deleteScheduledReports = payload => {
  return {
    type: DELETE_SCHEDULED_REPORTS,
    payload: payload
  }
}

export const deleteScheduledReportsSuccess = scheduled_reports => {
  return {
    type: DELETE_SCHEDULED_REPORTS_SUCCESS,
    payload: scheduled_reports,
  }
}

export const deleteScheduledReportsError = error => {
  return {
    type: DELETE_SCHEDULED_REPORTS_ERROR,
    payload: error,
  }
}

export const getScheduledReportLogsById = (payload, scheduled_report_id) => {
  return {
    type: GET_SCHEDULED_REPORT_LOGS_BY_ID,
    payload: payload,
    scheduled_report_id: scheduled_report_id
  }
}

export const getScheduledReportLogsByIdSuccess = (scheduled_report_logs, scheduled_report_id) => {
  return {
    type: GET_SCHEDULED_REPORT_LOGS_BY_ID_SUCCESS,
    payload: scheduled_report_logs,
    scheduled_report_id: scheduled_report_id
  }
}

export const getScheduledReportLogsByIdError = (error) => {
  return {
    type: GET_SCHEDULED_REPORT_LOGS_BY_ID_ERROR,
    payload: error,
  }
}

export const resetLastScheduledReportsAction = (error) => {
  return {
    type: RESET_LAST_SCHEDULED_REPORTS_ACTION,
    payload: error
  }
}

export const redirectToDownloadUrl = (scheduled_report_log_id) => {
  return {
    type: REDIRECT_TO_DOWNLOAD_URL,
    payload: scheduled_report_log_id
  }
}

export const redirectToDownloadUrlSuccess = (action) => {
  return {
    type: REDIRECT_TO_DOWNLOAD_URL_SUCCESS,
    payload: action
  }
}

export const redirectToDownloadUrlError = (error) => {
  return {
    type: REDIRECT_TO_DOWNLOAD_URL_ERROR,
    payload: error
  }
}

